import { FIELD_TYPE } from "@saleor/components/FormField/constants";
import { useFormik } from "formik";
import { useMemo } from "react";
import { useIntl } from "react-intl";

const customGridWidth = { flexBasis: "12.5%", maxWidth: "12.5%" };

const useSearchPMTFilter = () => {
  const formikData = useFormik({
    enableReinitialize: false,
    initialValues: {
      pc1: "",
      pc2: "",
      pc3: "",
      pc4: "",
      pc5: "",
      pc6: "",
      saleText: "",
      description: "",
      partNo: "",
      matLength: "",
      matWidth: "",
      matHeight: "",
      custId: "",
      custName: ""
    },
    onSubmit: data => {
      console.warn(data);
    }
  });

  const intl = useIntl();

  const formData = useMemo(
    () => [
      {
        title: intl.formatMessage({ defaultMessage: "PC" }),
        name: "pc1",
        type: FIELD_TYPE.SINGLE_INPUT,
        maxLength: 20,
        md: 2,
        sm: 2
      },
      {
        title: intl.formatMessage({ defaultMessage: " " }),
        name: "pc2",
        type: FIELD_TYPE.SINGLE_INPUT,
        maxLength: 20,
        md: 2,
        sm: 2
      },
      {
        title: intl.formatMessage({ defaultMessage: " " }),
        name: "pc3",

        type: FIELD_TYPE.SINGLE_INPUT,
        maxLength: 20,
        md: 2,
        sm: 2
      },
      {
        title: intl.formatMessage({ defaultMessage: " " }),
        name: "pc4",

        type: FIELD_TYPE.SINGLE_INPUT,
        maxLength: 20,
        md: 2,
        sm: 2
      },
      {
        title: intl.formatMessage({ defaultMessage: " " }),
        name: "pc5",

        type: FIELD_TYPE.SINGLE_INPUT,
        maxLength: 20,
        md: 2,
        sm: 2
      },
      {
        title: intl.formatMessage({ defaultMessage: " " }),
        name: "pc6",

        type: FIELD_TYPE.SINGLE_INPUT,
        maxLength: 20,
        md: 2,
        sm: 2
      },
      {
        title: intl.formatMessage({ defaultMessage: "Sale Text" }),
        name: "saleText",
        type: FIELD_TYPE.SINGLE_INPUT,
        maxLength: 160,
        md: 6,
        sm: 6
      },
      {
        title: intl.formatMessage({ defaultMessage: "Description" }),
        name: "description",
        type: FIELD_TYPE.SINGLE_INPUT,
        maxLength: 40,
        md: 6,
        sm: 6
      },
      {
        title: intl.formatMessage({ defaultMessage: "Customer ID" }),
        name: "custId",
        type: FIELD_TYPE.SINGLE_INPUT,
        maxLength: 10,
        md: 2,
        sm: 2
      },
      {
        title: intl.formatMessage({ defaultMessage: "Customer Name" }),
        name: "custName",
        type: FIELD_TYPE.SINGLE_INPUT,
        maxLength: 200,
        md: 4,
        sm: 4
      },
      {
        title: intl.formatMessage({ defaultMessage: "Part No." }),
        name: "partNo",
        type: FIELD_TYPE.SINGLE_INPUT,
        maxLength: 40,
        md: 1,
        sm: 1,
        gridStyle: customGridWidth
      },
      {
        title: intl.formatMessage({ defaultMessage: "Length" }),
        name: "matLength",
        type: FIELD_TYPE.NUMBER_INPUT,
        maxLength: 10,
        md: 1,
        sm: 1,
        gridStyle: customGridWidth
      },
      {
        title: intl.formatMessage({ defaultMessage: "Width" }),
        name: "matWidth",
        type: FIELD_TYPE.NUMBER_INPUT,
        maxLength: 10,
        md: 1,
        sm: 1,
        gridStyle: customGridWidth
      },
      {
        title: intl.formatMessage({ defaultMessage: "Height" }),
        name: "matHeight",
        type: FIELD_TYPE.NUMBER_INPUT,
        maxLength: 10,
        md: 1,
        sm: 1,
        gridStyle: customGridWidth
      }
    ],
    []
  );

  return {
    formikData,
    formData
  };
};

export default useSearchPMTFilter;
